package org.teddapp.project.portfolio.export

/** Rendu Markdown d'un [PortfolioDoc] : pur, sans dépendance d'interface, testable. */
object PortfolioMarkdown {

    fun render(doc: PortfolioDoc): String = buildString {
        appendLine("# ${doc.title}")
        doc.subtitle?.takeIf { it.isNotBlank() }?.let { appendLine(); appendLine("_${it}_") }
        appendLine()
        appendLine("_Généré le ${doc.generatedAt}_")
        appendLine()
        doc.blocks.forEach { block ->
            when (block) {
                is DocBlock.Heading -> appendLine("#".repeat((block.level + 1).coerceIn(2, 6)) + " " + block.text)
                is DocBlock.Paragraph -> appendLine(block.text)
                is DocBlock.Markdown -> appendLine(block.text.trimEnd())
                is DocBlock.Bullets -> block.items.forEach { appendLine("- $it") }
                is DocBlock.KeyValues -> block.pairs.forEach { (k, v) -> appendLine("- **$k** : $v") }
                is DocBlock.Tags -> appendLine(block.items.joinToString(" · ") { "`$it`" })
                is DocBlock.LevelBar -> appendLine(levelLine(block))
                is DocBlock.Links -> block.items.forEach { (label, url) -> appendLine("- [$label]($url)") }
                is DocBlock.Images -> block.items.forEach { (url, caption) -> appendLine("![${caption}]($url)") }
                DocBlock.Divider -> appendLine("---")
                DocBlock.PageBreak -> { appendLine(); appendLine("---") }
            }
            appendLine()
        }
    }.trimEnd() + "\n"

    internal fun levelLine(block: DocBlock.LevelBar): String {
        val total = block.distribution.sum()
        val aggregate = block.aggregate?.let { LEVEL_LABELS.getOrNull(it) } ?: "—"
        val parts = block.distribution.toList().mapIndexedNotNull { i, n -> if (n > 0) "$n ${LEVEL_LABELS[i].lowercase()}" else null }
        return "**Niveau : $aggregate** · $total critère${if (total > 1) "s" else ""}" +
            (if (parts.isNotEmpty()) " (${parts.joinToString(", ")})" else "")
    }
}
